import p from "lodash/isFunction";
import { warn as g } from "../../utils/console.js";
function h() {
  return Math.random().toString(36).substr(2, 10);
}
function y(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function M(t) {
  return t === 0 ? !1 : y(t) ? !Object.keys(t).length : Array.isArray(t) && t.length === 0 ? !0 : !t;
}
function N(t) {
  return (...e) => !t(...e);
}
function b(t, e) {
  return t === void 0 && (t = "undefined"), t === null && (t = "null"), t === !1 && (t = "false"), t.toString().toLowerCase().includes(e.trim());
}
function x(...t) {
  return (e) => t.reduce((n, o) => o(n), e);
}
function w(t, e, n, o) {
  return t.filter((l) => b(o(l, n), e));
}
function S({ search: t, hasGroups: e, groupOptionsKey: n, groupLabelKey: o, valueKey: l }) {
  const f = { isTag: !0, label: t, type: "option" };
  return e ? {
    [o]: "pending-tag-group",
    [l]: `tag-${h()}`,
    [n]: [f]
  } : f;
}
function m(t, e, n, o) {
  return (l) => l.reduce((f, i) => {
    if (i[t] && i[t].length) {
      const r = i[t].map((c) => ({
        type: "option",
        ...c
      }));
      let s = i[n];
      const u = ["default", "divider"].filter(
        (c) => [i[e], s].includes(c)
      )[0], a = i[e] === "pending-tag-group";
      return !s && !u && (s = i[e].toLowerCase(), g(
        `Group for '${i[e]}' does not contain a key matching the supplied 'valueKey' of '${n}'. Make sure the group object has a '${n}' key in it. Failure to include this key can affect rendering of the options list.`,
        this
      )), a || u ? (u === "divider" && f.length && r[0] && (r[0].divided = !0), f.concat(r)) : (f.push({
        label: i[e],
        [n]: s,
        disabled: !o,
        ...i,
        type: "group",
        [e]: i[e],
        [t]: r
      }), f.concat(i[t]));
    }
    return f;
  }, []);
}
function k(t, e, n, o, l) {
  return (f) => f.map((i) => {
    const r = w(i[n], t, e, l);
    return r.length ? {
      ...i,
      [o]: i[o],
      [n]: r
    } : [];
  });
}
function B(t) {
  return t.filter((e) => e.type !== "group");
}
function E(t, e, n, o) {
  return x(m(t, e, n), B)(o);
}
function d(t, e, n, o, l) {
  const f = n.length, i = n[e];
  if (!i || !i.disabled)
    return e;
  if (t > 0) {
    for (let r = e + 1; r < f; r++)
      if (!n[r].disabled)
        return r;
  } else
    for (let r = e - 1; r >= 0; r--)
      if (!n[r].disabled)
        return r;
  return l ? t > 0 ? d(1, 0, n) : d(-1, f - 1, n) : -1;
}
function F(t, e, n, o, l = !0) {
  const f = n.length, i = f - 1;
  (typeof e != "number" || e < 0 || e >= f) && (e = t > 0 ? -1 : i + 1);
  let r = e + t;
  r < 0 ? r = l ? i : 0 : r > i && (r = l ? 0 : i);
  const s = d(t, r, n, o, l);
  return s === -1 ? e : s;
}
const $ = {
  medium: 36,
  small: 32,
  mini: 26
};
function O(t) {
  return t.sort((e, n) => n.label.length - e.label.length).slice(0, 10);
}
function A(t) {
  const e = document.createElement("canvas"), n = e.getContext("2d"), o = '400 14px "Inter", Helvetica Neue, Arial, sans-serif', l = '400 12px "Inter", Helvetica Neue, Arial, sans-serif', f = O(t), i = [];
  return f.forEach(({ type: r, label: s }) => {
    n.clearRect(0, 0, e.width, e.height);
    let u = s;
    r === "group" ? (n.font = l, u = s.toUpperCase()) : n.font = o;
    const { width: a } = n.measureText(u);
    i.push(r === "group" ? a * 1.3 : a);
  }), Math.max(...i);
}
const C = new Intl.Collator("en", { numeric: !0, sensitivity: "base" });
function G(t, e) {
  return t === e ? 0 : t ? -1 : 1;
}
function D(t, e, n) {
  let o, l;
  n.sortBy ? p(n.sortBy) ? (o = n.sortBy(t), l = n.sortBy(e)) : (o = t[n.sortBy], l = e[n.sortBy]) : n.formatOptionLabel ? (o = n.formatOptionLabel(t, n.labelKey), l = n.formatOptionLabel(e, n.labelKey)) : (o = t[n.labelKey], l = e[n.labelKey]);
  let f = 0;
  return !!o === o && !!l === l ? f = G(o, l) : f = C.compare(o, l), f;
}
export {
  $ as TRIGGER_SIZE_MAP,
  A as calculateMinMenuWidthFromLabels,
  S as createTaggableOption,
  k as filterGroups,
  w as filterOptions,
  E as flatAndStrip,
  m as flattenOptions,
  x as flow,
  h as generateId,
  O as getLongestOptionLabels,
  d as getNextNonDisabledIndex,
  F as getNextWrappingIndex,
  b as includes,
  M as isEmpty,
  y as isObject,
  N as not,
  D as sortData,
  B as stripGroups
};
//# sourceMappingURL=multiselect-helper.js.map
